import React from 'react';
import { AppButton, Box, Preloader } from '@common-fe/common-fe';

import { PendingModal } from '@/components/elements';
interface Props {
  visible: boolean;
  onSetVisible: (value: boolean) => void;
  onRemoveSubmit: () => void;
  isLoading?: boolean;
}
const ScheduledReportInboxItemRemoveModal: React.FC<Props> = ({
  visible,
  onSetVisible,
  onRemoveSubmit,
  isLoading,
}) => {
  return (
    <PendingModal visible={visible} onSetVisible={onSetVisible} header="Remove this report?" helptext="">
      <Box data-testid="scheduled-modal_remove_modal" direction="row">
        <AppButton
          testId="scheduled-modal_remove_cancel"
          onClick={() => onSetVisible(true)}
          width="240px"
          buttonType="secondary"
        >
          Cancel
        </AppButton>
        <Box margin={{ right: 'spacing12' }}></Box>
        <AppButton
          testId="scheduled-modal_remove_apply"
          color="red"
          disabled={isLoading}
          onClick={onRemoveSubmit}
          width="240px"
        >
          {isLoading ? <Preloader testId="scheduled-modal_remove_apply_loading" /> : 'Yes, Remove'}
        </AppButton>
      </Box>
    </PendingModal>
  );
};

export default ScheduledReportInboxItemRemoveModal;
